import { createSlice } from "@reduxjs/toolkit";
import { NewUserModalFieldJSON } from "../../pages/IpSettings/IpWhitelisting/Json/NewUserModalFieldJson";
import { IP_FROM_DATE, IP_TO_DATE } from "../../Utils/FilterDateKeys";
import dateFormat from "dateformat";

const initialState = {
  newUserModalFieldJson: NewUserModalFieldJSON,
  whiteListedData: {},
  whiteListEdit: {
    id: null,
  },
  filter: {
    filterApi: true,
    form: {
      // enterpriseid: enterpriseid,
      // user_id: userid,
      // [ORD_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      // [ORD_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
    formCopy: {
      [IP_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      [IP_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
  },
  sorting: {
    column: "code",
    order: "DESC",
  },
  ipFilter: {
    filterApi: true,
    form: {
      // enterpriseid: enterpriseid,
      // user_id: userid,
      // [ORD_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      // [ORD_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
    formCopy: {
      [IP_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
      [IP_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
    },
  },
};

const ipSettingsSlice = createSlice({
  name: "ipSettings",
  initialState,
  reducers: {
    setNewUserFieldJson(state, action) {
      state.newUserModalFieldJson = action.payload;
    },
    setWhiteListedData(state, action) {
      state.whiteListedData = action.payload;
    },
    setWhiteListedEdit(state, action) {
      state.whiteListEdit = action.payload;
    },
    setIpFilterApi(state, action) {
      state.filter.filterApi = action.payload;
    },
    // setOrderFilterForm: (state, action) => {
    //   state.filter.form = action.payload;
    // },
    setIpFilterForm(state, action) {
      switch (action?.payload.type) {
        case "reset":
          state.filter.form = {
            // [ORD_FROM_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
            // [ORD_TO_DATE]: dateFormat(new Date(), "yyyy-mm-dd"),
            // enterpriseid: enterpriseid,
            // user_id: userid,
          };
          state.filter.isFormChanged = true;
          state.filter.formCopy = state.filter.form;
          break;
        case "disableApplySpam":
          state.filter.isFormChanged = false;
          break;
        case "clearDate":
          delete state.filter.form[IP_FROM_DATE];
          delete state.filter.form[IP_TO_DATE];
          state.filter.isFormChanged = true;
          break;
        default:
          state.filter.form = {
            ...state.filter.form,
            [action.payload.name]: action.payload.value,
          };
          state.filter.isFormChanged = true;
      }
    },
    setIpFilterFormCopy(state, action) {
      state.filter.formCopy = action.payload;
    },
    setIpSorting(state, action) {
      state.sorting = {
        column: action.payload?.column,
        order: action.payload?.order,
      };
    },
    setIpFilterApi(state, action) {
      state.transactionFilter.filterApi = action.payload;
    },
  },
});

export const {
  setNewUserFieldJson,
  setWhiteListedData,
  setWhiteListedEdit,
  setIpFilterApi,
  setIpSorting,
  setIpFilterFormCopy,
  setIpFilterForm,
} = ipSettingsSlice.actions;

export default ipSettingsSlice.reducer;
